// Package imports:
import React from 'react';
// Component imports:
import Flag, { FlagNames } from '../../../ui-elements/Flag/Flag';
import LmdTable from '../../../ui-elements/Table/LmdTable';
// Service imports:
import { formatNumber, getTableDate } from '../../../services/utils';
import { useApiLmdData } from '../../../services/apiHooks';
// Type imports:
import { IDefaultProps } from '../../../types/Types';
import { IApiLmdCurrency } from '../../../types/CurrencyTypes';

const CURRENCIES = ['CAD','CHF','DKK','EUR','GBP','JPY','NOK','SEK','USD','XDR'];

type Props = IDefaultProps;

const Sedlabankinn: React.FC<Props> = ({
    accessToken,
    refreshRateMs
}) => {
    const [ sedlabankinnCurrencies ] = useApiLmdData<IApiLmdCurrency[]>(
        `/v1/market_data/v1/keldan/base_currency/CBI/cross_currency_list/[${CURRENCIES.join(';')}]/snapshot`,
        accessToken,
        refreshRateMs
    );

    const handleData = () => {
        const { data, error } = sedlabankinnCurrencies;
        if (data === null) {
            return sedlabankinnCurrencies;
        } else {
            const sortedData = [...data].sort((a, b) => (
                (a.Crosscurrency === null)
                ? -1
                : (b.Crosscurrency === null)
                ? 1
                : (a.Crosscurrency === null && b.Crosscurrency === null)
                ? 0
                : CURRENCIES.indexOf(a.Crosscurrency) - CURRENCIES.indexOf(b.Crosscurrency))
            );
            return {
                data: sortedData,
                error
            }
        }
    }
    
    return (
        <div className='KCL_sedlabankinn'>
            <LmdTable
                apiData={handleData()}
                columns={[{
                    title: 'Gjaldmiðill',
                    dataAccessor: ({Crosscurrency}) => (
                        <div className='flag-and-symbol'>
                            <span className='flag'>
                                <Flag name={Crosscurrency as FlagNames} />
                            </span>
                            <span className='symbol'>
                                {Crosscurrency}
                            </span>
                        </div>
                    ),
                    textAlign: 'left',
                    simpleSortable: ({Crosscurrency}) => Crosscurrency
                }, {
                    title: 'Miðgengi',
                    dataAccessor: ({Averagerate}) => formatNumber(Averagerate),
                    simpleSortable: ({Averagerate}) => Averagerate
                }, {
                    title: 'Dags.',
                    dataAccessor: ({Datetimerate}) => getTableDate(Datetimerate, 'DD/MM/YY', '.'),
                    simpleSortable: ({Datetimerate}) => (Datetimerate === null) ? null : new Date(Datetimerate.replace(/ /g, "T")).getTime()
                }]}
            />
        </div>
    );
}

export default Sedlabankinn;